// extracted by mini-css-extract-plugin
export default {"recos":"L3-z","productCardOverride":"M3-z","rowHasBadge":"N3-z"};